export default __webpack_public_path__ + "static/media/frontend.5e297224.png";